/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React from "react";
import { Link, useHistory } from "react-router-dom";
import clsx from "clsx";
import { additionalVideos, lineup } from "../../../../assets/data/lineup";
import { SessionItem } from "./components";
import "./styles.scss";
import { getEventBoxColor } from "../Lineup/components/LineupTab/lineup-tab";


interface PrevEvent {
 id: number;
 color: string;
 title: string;
 embedId: string;
 thumbnailId: string;
}

export const PreviousSessions = (): JSX.Element => {
 const history = useHistory();
// @ts-ignore
  const previousEvents: PrevEvent[] = [...lineup, ...additionalVideos].sort((a, b) => a.id-b.id).filter(event => event.embedId !== undefined && event.thumbnailId !== undefined).map((event) => ({
    id: event.id,
    color: getEventBoxColor(event.type),
    title: event.title,
   embedId: event.embedId,
    thumbnailId: event.thumbnailId
  }));
  return (
    <div className="psp-wrapper">
        <div className="psp">
          <div className="psp-header">
            <div>
              <h3>Watch Previous Sessions</h3>
            </div>
          </div>
      <div className={clsx("psp-body")} >
            {previousEvents
              .map((event,index) => (
               <SessionItem item={event} key={event.id} index={index+1}/>
              ))}
       </div>
          <div
            className={clsx("psp-body-cover")}
          />
    </div>
    <div className="psp-footer">
    <button
              type="button"
              className="psp-link"
              onClick={() => {
                history.push("/videos");
              }}
            >
              <Link to="/videos">
                <h6>See all videos</h6>
              </Link>
     </button>
     </div>
    </div>
  );
};
